import React, { useState, useEffect } from 'react';
import packageJson from '../../package.json'; // Import package.json

// Loading spinner showing countdown to next auto-save (30s)
const LoadingSpinner = () => {
  const [progress, setProgress] = useState(0);
  useEffect(() => {
    let start = Date.now();
    const update = () => {
      const elapsed = Date.now() - start;
      let percent = (elapsed / 30000) * 100;
      if (percent >= 100) {
        start = Date.now();
        percent = 0;
      }
      setProgress(percent);
    };
    update();
    const interval = setInterval(update, 1000);
    return () => clearInterval(interval);
  }, []);
  const circumference = 2 * Math.PI * 45;
  const offset = circumference * (1 - progress / 100);
  return (
    <div className="autosave-container">
      <span className="autosave-text">nächste Zwischenspeicherung</span>
      <svg
        width="40"
        height="40"
        viewBox="0 0 100 100"
        style={{ transform: 'rotate(-90deg)', marginLeft: '10px' }}
      >
        <circle cx="50" cy="50" r="45" stroke="#eee" strokeWidth="10" fill="none" />
        <circle
          cx="50"
          cy="50"
          r="45"
          stroke="#4caf50"
          strokeWidth="10"
          fill="none"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          style={{ transition: 'stroke-dashoffset 1s linear' }}
        />
      </svg>
    </div>
  );
};

const Header = () => {
  const version = packageJson.version; // Get version from package.json

  return (
    <header className="header">
      <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
        <img src="/icons/logo192.svg" alt="Changing-Teams Mix&Match Logo" width={48} height={48} className="app-logo" />
        <div style={{ flex: 1 }}>
          <h1>Changing-Teams Turnierplaner</h1>
          <p className="header-subtitle">Mix&Match - Erstellen und verwalten Sie Ihr Turnier mit zufällig wechselnden Teams in jeder Runde</p>
        </div>
        {version && <span className="app-version">v{version}</span>}
        <LoadingSpinner />
      </div>
    </header>
  );
};

export default Header;